import React from 'react';

import SyncIconActive from '@/icons/wizard/sync.inline.svg';
import SyncIconDisabled from '@/icons//wizard/sync-disabled.inline.svg';

const SyncButton = props => {
  const { selWizard, setIsCableFlagSyncState, cableFlagWizardSyncPoligon, x, y, width, height } = props;

  const [isCableFlagSync, setIsCableFlagSync] = React.useState(!!selWizard?.data?.isCableFlagSync);

  const changeSyncState = () => {
    const newState = !isCableFlagSync;
    setIsCableFlagSync(newState);
    setIsCableFlagSyncState(newState);
  };

  return selWizard?.data?.isCableFlagSync ? (
    <>
      <path d={cableFlagWizardSyncPoligon} fill="none" stroke="grey" strokeWidth={0.1} />
      <SyncIconActive
        id="group-cable-flag-wizard-sync-button"
        x={x}
        y={y}
        width={width}
        height={height}
        viewBox="0 0 32 16"
        className="clickable"
        onClick={() => changeSyncState()}
        onTouchEnd={() => changeSyncState()}
      />
    </>
  ) : (
    <>
      <path d={cableFlagWizardSyncPoligon} fill="none" stroke="grey" strokeDasharray="0.75,0.35" strokeWidth={0.1} />
      <SyncIconDisabled
        id="group-cable-flag-wizard-sync-disabled-button"
        x={x}
        y={y}
        width={width}
        height={height}
        viewBox="0 0 32 16"
        className="clickable"
        onClick={() => changeSyncState()}
        onTouchEnd={() => changeSyncState()}
      />
    </>
  );
};

export default SyncButton;